import create from 'zustand'
import { ApolloError } from '@apollo/client'
import { MeetingRequestOptionsQuery } from '../../types'
import { client } from '../../index'
import { MEETING_REQUEST_OPTIONS } from './requestMeetingOptions'

type MeetingRequestOptionsState = {
  data: MeetingRequestOptionsQuery | null
  error: ApolloError | null
  loading: boolean
  /** employeeId for which we have data (set when on OwnGrowthPage) */
  employeeId: string | number | null
  setOptions: (
    data: MeetingRequestOptionsQuery | null,
    error: ApolloError | null,
    loading: boolean,
    employeeId: string | number | null,
  ) => void
  refetch: (employeeId: string | number) => Promise<void>
  clear: () => void
}

const initialState = {
  data: null,
  error: null,
  loading: false,
  employeeId: null,
}

export const useMeetingRequestOptionsStore = create<MeetingRequestOptionsState>((set) => ({
  ...initialState,

  setOptions: (data, error, loading, employeeId) =>
    set({
      data,
      error,
      loading,
      employeeId,
    }),

  refetch: async (employeeId) => {
    set({ loading: true, error: null })
    const result = await client.query({
      query: MEETING_REQUEST_OPTIONS,
      variables: { employeeId },
      fetchPolicy: 'network-only',
    })
    set({
      data: result.data,
      error: result.error || null,
      loading: false,
      employeeId,
    })
  },

  clear: () => set(initialState),
}))
